import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1dafa849&scoped=true&"
import script from "./taskCentered.ts?vue&type=script&lang=ts&"
export * from "./taskCentered.ts?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=1dafa849&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dafa849",
  null
  
)

export default component.exports